<template>
    <div>
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">Create Subsidiary</h1>
                <div @click="hideModal">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>

            <div class="w-full flex">
                <div class="w-full flex p-4">
                    <div class="flex flex-1 flex-col py-3 px-6">
                        <div class="flex flex-col mb-4">
                            <div class="flex-1 mb-6">
                                <label class="block text-sm mb-2" for="name">Name</label>
                                <input type="text" name="name" class="form-input w-full" v-model="subsidiary.name">
                                <div v-if="errors.name" class="form-error">{{ errors.name[0] }}</div>
                            </div>

                            <div class="bg-gray-100">
                                <div class="flex flex-col shadow-md rounded border border-gray-300 p-4">
                                    <div class="mb-5 flex flex-col flex-grow">
                                        <label class="block text-sm mb-2" for="country">Country</label>
                                        <select v-model="subsidiary.country_id" class="mt-0 form-select">
                                            <option value=""></option>
                                            <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.name }}</option>
                                        </select>
                                        <div v-if="errors.country_id" class="form-error">{{ errors.country_id[0] }}</div>
                                    </div>
                                    <div class="mb-5">
                                        <label class="block text-sm mb-2" for="address">Address</label>
                                        <input v-model="subsidiary.address" type="text" class="form-input w-full">
                                        <div v-if="errors.address" class="form-error">{{ errors.address[0] }}</div>
                                    </div>

                                    <div class="flex mb-5">
                                        <div class="mr-4">
                                            <label class="block text-sm mb-2" for="city">City</label>
                                            <input v-model="subsidiary.city" type="text" class="form-input">
                                            <div v-if="errors.city" class="form-error">{{ errors.city[0] }}</div>
                                        </div>
                                        <div v-if="subsidiary.country_id == 16" class="mr-4">
                                            <label class="block text-sm mb-2" for="state">State</label>
                                            <select v-model="subsidiary.state" class="form-select">
                                                <option value=""></option>
                                                <option v-for="(state, stateIndex) in states" :key="stateIndex" :value="state.state">{{ state.state }}</option>
                                            </select>
                                            <div v-if="errors.state" class="form-error">{{ errors.state[0] }}</div>
                                        </div>
                                        <div>
                                            <label class="block text-sm mb-2" for="postal_code">Postal Code</label>
                                            <input v-model="subsidiary.postal_code" type="text" class="form-input">
                                            <div v-if="errors.postal_code" class="form-error">{{ errors.postal_code[0] }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bg-gray-100 p-4">
                <div class="text-right">
                    <button class="btn btn-secondary mr-2" @click.prevent="hideModal">Close</button>
                    <button class="btn btn-green" @click.prevent="save">
                        <span v-if="loading">
                            <inline-svg name="loading-button"></inline-svg>
                        </span>
                        <span v-if="! loading">Save</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            clientId: {
                type: Number,
                required: false,
                default: null
            }
        },

        data() {
            return {
                subsidiary: {
                    client_id: this.clientId || window.user.client.id,
                    country_id: 16
                },
                countries: {},
                states: {},
                errors: '',
                loading: false           
            }
        },

        mounted() {
            axios.get('/api/address-info').then((response) => {
                this.countries = response.data.countries;
                this.states = response.data.states;
            }).catch((error) => {
                console.log(error);
            });
        },

        methods: {
            save() {
                this.loading = true;
                
                axios.post('/subsidiaries', this.subsidiary)
                    .then((response) => {
                        this.$emit('subsidiaryCreated', response.data.subsidiary);
                        
                        this.hideModal();
                        
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        });
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                    }
                ).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>